module.exports = __webpack_public_path__ + "static/media/phone.5b2bc7f5.png";